import { render, staticRenderFns } from "./ScrollLayout.vue?vue&type=template&id=045b4088&scoped=true"
import script from "./ScrollLayout.vue?vue&type=script&lang=js"
export * from "./ScrollLayout.vue?vue&type=script&lang=js"
import style0 from "./ScrollLayout.vue?vue&type=style&index=0&id=045b4088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b4088",
  null
  
)

export default component.exports